"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var taskTemplates;
        (function (taskTemplates) {
            var details;
            (function (details) {
                class InitArgs {
                    constructor() {
                        this.latLonUser = appn.emptyString;
                        this.firstToClaimId = appn.emptyString;
                        this.allToCompleteId = appn.emptyString;
                        this.modelCanSave = false;
                    }
                }
                let _initArgs;
                function init(args) {
                    _initArgs = args;
                    appn.tasks.init(_initArgs.firstToClaimId, _initArgs.allToCompleteId, true);
                    appn.tasks.initAddressMap({
                        completeAtLot: 'Template_Task_CompleteAtLot',
                        completeAtText: 'Template_Task_CompleteAtText',
                        completeAtCountry: 'Template_Task_CompleteAtCountry',
                        completeAtLat: 'Template_Task_CompleteAtLat',
                        completeAtLon: 'Template_Task_CompleteAtLon'
                    }, _initArgs.latLonUser, _initArgs.modelCanSave);
                    if ($('nav .navbar-nav-right button[value*="Trash"]').length > 0)
                        appn.trash.addTrashMessage($('nav .navbar-nav-right button[value*="Trash"]'), '#Template_Task_Name', undefined, undefined, false);
                }
                details.init = init;
            })(details = taskTemplates.details || (taskTemplates.details = {}));
        })(taskTemplates = views.taskTemplates || (views.taskTemplates = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
